import { Injectable } from '@angular/core';
import { BaseService, Game, TournamentApi } from '@mtgame/core';
import { Observable } from 'rxjs';

const STORE_GAMES_KEY = 'games';

@Injectable()
export class TournamentPlayoffWidgetService extends BaseService {
  playoffId: number;

  get games$(): Observable<Game[]> {
    return this.store.get(STORE_GAMES_KEY);
  }

  constructor(
    private tournamentApi: TournamentApi,
  ) {
    super();
  }

  async initialize(playoffId: number): Promise<any> {
    this.playoffId = playoffId;
    return this.getGames();
  }

  async getGames(): Promise<Game[]> {
    const games = await this.tournamentApi.getPlayoffGames(this.playoffId);
    this.store.save(STORE_GAMES_KEY, games);
    return games;
  }
}
